import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';

const InputButton = (props: ButtonProps) => {
	const { children, ...rest } = props;
	return <Button variant="outlined" {...rest}>{children}</Button>;
}

export default InputButton;